import { Grid, Typography, Divider } from "@mui/material";

function AboutUs() {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ m: "2%", fontWeight: "bold" }}>
          {" "}
          About This Project
        </Typography>
        <Divider variant="middle" sx={{ m: "2%" }} />
      </Grid>
    </Grid>
  );
}

export default AboutUs;
